// extracted by mini-css-extract-plugin
export var container = "_f7-0";
export var content = "_f7-3";
export var customerTitle = "_f7-4";
export var empty = "_f7-5";
export var gray = "_f7-6";
export var header = "_f7-7";
export var info = "_f7-8";
export var loading = "_f7-2";
export var loadingCard = "_f7-9";
export var oneLine = "_f7-a";
export var personName = "_f7-e";
export var pillContainer = "_f7-b";
export var selected = "_f7-1";
export var text = "_f7-c";
export var twoLines = "_f7-d";
export var unread = "_f7-f";
export var unreadIndicator = "_f7-g";